import { useMutation, useQueryClient } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axios/editorInstance'
import extract from '@pepper/utils/src/function/extract'

type Props = {
  docId: string
  body: {
    title: string
  }
}

async function updateDocumentDetails({ docId, body }: Props) {
  const url = `/v2/documents/${docId}/details`
  const response = await axios.put(url, body)
  return extract.data<ApiResponse>(response)
}

export function useUpdateDocumentDetails() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateDocumentDetails,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['doc', 'content', variables.docId])
    }
  })
}
